<template>
	<b-card-body>
		<div class="row">
			<div class="col">
				<p>Available: {{ranksAvailable}} | Used: {{ranksUsed}}</p>
			</div>
		</div>
		<div class="skill-columns-thick">
			<div class="col" v-for="(ranks, skill) in skills" :key="`skill-ranks-${level}-${skill}`" style="break-inside:avoid;">
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text" style="min-width: 9em;">{{skill}}</span>
					</div>
					<input type="number" class="form-control" v-model.number="skills[skill]" />
					<div class="input-group-append">
						<span class="input-group-text" style="min-width: 3em;">{{totalRanks[skill]}}</span>
					</div>
				</div>
			</div>
			<div class="col"></div>
			<div class="col"></div>
		</div>
	</b-card-body>
</template>

<script>
export default {
	props: [
		'level',
	],
	computed: {
		skills: function() {
			return this.$store.state.Character.Levels[this.level].Skills
		},
		totalRanks: function() {
			return this.$store.getters['character/skills/ranksAtLevel'][this.level]
		},
		ranksAvailable: function() {
			return this.$store.getters['character/skills/ranksAvailable'][this.level]
		},
		ranksUsed: function() {
			return this.$store.getters['character/skills/ranksUsed'][this.level]
		}
	},
	watch: {
		skills: {
			deep: true,
			handler: function(value){
				this.$store.commit('setCharacterProp',[
					{
						key: `Levels[${this.level}].Skills`,
						val: value,
					}
				])
			}
		}
	}
}
</script>

<style scoped>

</style>